<template>
  <container-component class="cc-protected">
    <div class="wrapper">
      <form class="w-full max-w-sm" @submit.prevent="onSubmit">
        <div class="flex items-center border-b border-b-2 border-teal-500 py-2">
          <input
            v-model="password"
            class="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none" type="password"
            placeholder="Password"
            aria-label="Password"
            @input="flashError = false"
            @click="flashError = false"
            @keyup.enter="validatePassword"
          >
          <button
            class="flex-shrink-0 bg-teal-500 hover:bg-teal-700 border-teal-500 hover:border-teal-700 text-sm border-4 text-white py-2 px-2 rounded" type="button"
            @click="validatePassword"
          >
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="20" height="20" viewBox="0 0 24 24"><path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" /></svg>
          </button>
        </div>
      </form>
      <div
        v-if="flashError"
        class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-full max-w-sm mt-8" role="alert"
      >
        <strong class="font-bold">Nope.&nbsp;</strong>
        <span class="block sm:inline">Try again?</span>
        <span class="absolute top-0 bottom-0 right-0 px-4 py-3">
          <svg class="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
        </span>
      </div>
    </div>
  </container-component>
</template>

<script>
import ContainerComponent from "@/components/ContainerComponent.vue";

  export default {
    name: 'ProtectedPage',
    components: {
      ContainerComponent,
    },
    data() {
      return {
        storageKey: 'authorized',
        password: null,
        flashError: false,
      };
    },
    created() {
      console.log(process.env.VUE_APP_CONSUL_PW);
    },
    methods: {
      onSubmit() {
        return;
      },
      validatePassword() {
        const match = this.password === process.env.VUE_APP_CONSUL_PW;
        console.log({ pw: this.password, real: process.env.VUE_APP_CONSUL_PW })
        if (match) {
          this.openSesame();
        } else {
          this.flashError = true;
        }
      },
      async openSesame() {
        await localStorage.setItem(this.storageKey, this.password);
        this.$router.push({ name: 'consul' });
      }
    }
  }
</script>

<style lang="scss" scoped>
.cc-protected {
  display: flex;
  flex-direction: column;
  padding-top: 40vh;
  align-items: center;
  font-family: 'Space Grotesk';
  font-weight: 400;
}

input {
  font-size: 20px;
  line-height: 24px;
  @include max-width(640) {
    font-size: 16px;
    line-height: 20px;
  }
}

svg {
  width: 20px;
  height: 20px;
  fill: white;
}
</style>